import axios from "@/axios";
import { formatSections } from "@/modules/field-editor/services.js";

const getChecksList = async (tenantId, count=100, params) => {
    let url = `/tenant-check/${tenantId}?count=${count}`;
    try {
        let { data } = await axios.get(url, params);
        return data.data
    }
    catch (error) {
        console.log(error, "Error")
    }
    // this.columns = columns;
}

const getChecksAssignedtoClient = async (clientId) => {
    const url = `/tenant-check/client-checks/${clientId}`;
    try {
        let { data } = await axios.get(url);
        return data.data;
    } catch (error) {
        console.log(error);
    }
};

const getPackagesCheck = async (packageId) => {
    const url = `/screening-package/${packageId}/check`
    try {
        const { data } = await axios.get(url)
        return data
    } catch (error) {
        console.warn("some error in fetching package checks..")
    }
}

// external_id = tenant Id
const getEmailSquencesAll = async(external_id) => {
    const url = `/email-sequence/list?external_id=${external_id}`
    try {
        const { data } = await axios.get(url)
        return data.content
    } catch (error) {
        console.warn(error.response.data.detail || "Email sequences not found")
    }
}

const getEmailSquences = async(external_id) => {
    const url = `/email-sequence/linearlist?external_id=${external_id}`
    try {
        const { data } = await axios.get(url)
        return data
    } catch (error) {
        console.warn(error.response.data.detail || "Email sequences not found")
    }
}

const getCheckPermissions = async({ checkId, packageId }) => {
    const url = `/screening-package/${packageId}/check/${checkId}/access-groups`;
    try {
        const { data } = await axios.get(url);
        return data;
    } catch (error) {
        console.warn(error.response.data.detail || "Failed to fetch check permissions");
    }
}


const getTempCheckPermissions = async({ checkId, packageId }) => {
    console.log("getTempCheckPermissions", checkId, packageId);
    const url = `screening-package/7fa96389-1b16-412c-9102-0a60f23e7c6e/form/82b3e62f-891f-47f4-8f98-7ad7a7e02765/entity/0eff00b1-dcb0-4be5-aafd-5f8b90bf83dd/access-groups`;
    // const url = `/screening-package/${packageId}/check/${checkId}/access-groups`;
    try {
        const { data } = await axios.get(url);
        return data;
    } catch (error) {
        console.warn(error.response.data.detail || "Failed to fetch check permissions");
    }
}

const updateTempCheckPermissions = async({ checkId, packageId, data: payload }) => {
     console.log("updateCheckPermissions", checkId, packageId);
    // const url = `/screening-package/${packageId}/check/${checkId}/access-groups`;
        const url = `screening-package/7fa96389-1b16-412c-9102-0a60f23e7c6e/form/82b3e62f-891f-47f4-8f98-7ad7a7e02765/access-groups`;
    try {
        payload.entity_type_id = "eb7c4399-eae1-4513-98e6-035bce130151";
        const { data } = await axios.put(url, payload);
        return data;
    } catch (error) {
        console.warn(error.response.data.detail || "Failed to update check permissions");
    }
}

const updateCheckPermissions = async({ checkId, packageId, data: payload }) => {
    const url = `/screening-package/${packageId}/check/${checkId}/access-groups`;
    try {
        const { data } = await axios.put(url, payload);
        return data;
    } catch (error) {
        console.warn(error.response.data.detail || "Failed to update check permissions");
    }
}

function formatCheckFormData(data) {
    const { sections, parameters } = data;
    return {
        ...data,
        sections: formatSections(sections),
        parameters: JSON.parse(parameters)
    }
}

export {
    getChecksList,
    getPackagesCheck,
    getEmailSquencesAll,
    getEmailSquences,
    getChecksAssignedtoClient,
    getCheckPermissions,
    updateCheckPermissions,
    updateTempCheckPermissions,
    formatCheckFormData,
    getTempCheckPermissions,
}



